module.exports = __webpack_public_path__ + "static/media/icon-arrow-left.bdae2237.svg";